import styled, { css } from 'styled-components';

export const Container = styled.div`
   display: flex;
   min-width: 85px;
   flex-direction: column;
   border-radius: 10px;
   background-color: #ffffff;
   box-shadow: 0 1px 1px #ccc;
   padding: .3rem;
   gap: .5rem;

   .w-voice{
      max-width: 365px;
   }
   .w-audio{
      max-width: 365px;
   }
   .w-location {
      max-width: 310px;
   }
`

export const MessageReference = styled.div`
   > div {
      border-radius: 6px;
      border-left: 4px solid ${({ isUserSystem }) => isUserSystem ? '#00bcd4' : '#cccccc'};
      background-color: ${({ isUserSystem }) => isUserSystem ? '#E7F8FF' : '#cccccc36'};
   }
`;

export const MessageResponse = styled.div`
   > div:nth-child(1) {
      border-color: transparent;
      box-shadow: none;
   }
`;